var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84934 0.192261H10.5149L10.5416 0.200169C10.6303 0.226406 10.6937 0.287227 10.7364 0.344914C10.7803 0.404054 10.8136 0.474687 10.8388 0.547743C10.8889 0.693308 10.9153 0.874165 10.9132 1.06228C11.0504 7.01296 11.1946 12.9636 11.3458 18.9143C11.3517 19.1374 11.3056 19.3472 11.2152 19.5083C11.1267 19.6659 10.9745 19.8076 10.7662 19.8076H9.6182C9.40821 19.8076 9.25883 19.6639 9.17236 19.5069C9.08419 19.3469 9.03857 19.1391 9.03857 18.9192V18.9147C9.0867 16.8401 9.15213 14.0734 9.21676 11.3384C9.33657 6.2686 9.45381 1.30741 9.45381 1.0633C9.45381 0.859442 9.47987 0.677654 9.53079 0.534196C9.57771 0.402004 9.66426 0.252607 9.82029 0.201734L9.84934 0.192261ZM9.93566 0.576876C9.9259 0.589696 9.9102 0.615088 9.89325 0.662837C9.86127 0.752969 9.83842 0.888382 9.83842 1.0633C9.83842 1.31203 9.72036 6.30803 9.60014 11.3953C9.53587 14.115 9.47099 16.8609 9.42319 18.9213C9.42349 19.0921 9.45978 19.2316 9.50923 19.3213C9.5606 19.4145 9.60487 19.423 9.6182 19.423H10.7662C10.7812 19.423 10.8279 19.4125 10.8798 19.32C10.9298 19.2309 10.9658 19.0927 10.9613 18.9243C10.8101 12.9722 10.6658 7.01985 10.5286 1.06773L10.5284 1.06073C10.5305 0.906808 10.5085 0.769921 10.4751 0.673C10.4592 0.626865 10.4428 0.595572 10.4296 0.576876H9.93566Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61523 12.3077C3.61523 12.1802 3.71855 12.0769 3.846 12.0769H16.1537C16.2811 12.0769 16.3845 12.1802 16.3845 12.3077C16.3845 12.4351 16.2811 12.5384 16.1537 12.5384H3.846C3.71855 12.5384 3.61523 12.4351 3.61523 12.3077Z",
    fill: "#1E2447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.487 9.76929V10.9231H4.74341V11.6924H3.71777V10.9231H3.97418V9.76929H4.487Z",
    fill: "#1E2447"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64095 9C5.92417 9 6.15377 9.2296 6.15377 9.51282C6.15377 9.79604 5.92417 10.0256 5.64095 10.0256C5.45125 10.0256 5.2856 9.92264 5.1969 9.76951L3.26464 9.76925C3.17597 9.92252 3.01025 10.0256 2.82044 10.0256C2.53721 10.0256 2.30762 9.79604 2.30762 9.51282C2.30762 9.2296 2.53721 9 2.82044 9C3.01014 9 3.17578 9.103 3.26449 9.25613L5.19675 9.25639C5.28542 9.10312 5.45114 9 5.64095 9Z",
    fill: "#1E2447"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0256 9.76929V10.9231H16.282V11.6924H15.2563V10.9231H15.5128V9.76929H16.0256Z",
    fill: "#1E2447"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1795 9C17.4627 9 17.6923 9.2296 17.6923 9.51282C17.6923 9.79604 17.4627 10.0256 17.1795 10.0256C16.9898 10.0256 16.8242 9.92264 16.7355 9.76951L14.8032 9.76925C14.7145 9.92252 14.5488 10.0256 14.359 10.0256C14.0758 10.0256 13.8462 9.79604 13.8462 9.51282C13.8462 9.2296 14.0758 9 14.359 9C14.5487 9 14.7144 9.103 14.8031 9.25613L16.7353 9.25639C16.824 9.10312 16.9897 9 17.1795 9Z",
    fill: "#1E2447"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38428 5.38458C4.38428 5.25713 4.4876 5.15381 4.61505 5.15381H15.3843C15.5117 5.15381 15.615 5.25713 15.615 5.38458C15.615 5.51203 15.5117 5.61535 15.3843 5.61535H4.61505C4.4876 5.61535 4.38428 5.51203 4.38428 5.38458Z",
    fill: "#1E2447"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25605 2.84619V4.00004H5.51246V4.76927H4.48682V4.00004H4.74323V2.84619H5.25605Z",
    fill: "#1E2447"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40999 2.0769C6.69322 2.0769 6.92281 2.3065 6.92281 2.58972C6.92281 2.87295 6.69322 3.10255 6.40999 3.10255C6.22029 3.10255 6.05465 2.99954 5.96594 2.84641L4.03368 2.84615C3.94501 2.99943 3.77929 3.10255 3.58948 3.10255C3.30626 3.10255 3.07666 2.87295 3.07666 2.58972C3.07666 2.3065 3.30626 2.0769 3.58948 2.0769C3.77918 2.0769 3.94483 2.17991 4.03354 2.33304L5.96579 2.3333C6.05446 2.18002 6.22019 2.0769 6.40999 2.0769Z",
    fill: "#1E2447"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.256 2.84619V4.00004H15.5125V4.76927H14.4868V4.00004H14.7432V2.84619H15.256Z",
    fill: "#1E2447"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.41 2.0769C16.6932 2.0769 16.9228 2.3065 16.9228 2.58972C16.9228 2.87295 16.6932 3.10255 16.41 3.10255C16.2203 3.10255 16.0546 2.99954 15.9659 2.84641L14.0337 2.84615C13.945 2.99943 13.7793 3.10255 13.5895 3.10255C13.3063 3.10255 13.0767 2.87295 13.0767 2.58972C13.0767 2.3065 13.3063 2.0769 13.5895 2.0769C13.7792 2.0769 13.9448 2.17991 14.0335 2.33304L15.9658 2.3333C16.0545 2.18002 16.2202 2.0769 16.41 2.0769Z",
    fill: "#1E2447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16553 16.5428L10.9909 13.5947L11.1217 13.6757L9.29633 16.6238L9.16553 16.5428Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43213 10.5055L10.8367 7.53638L10.9758 7.60217L9.5712 10.5713L9.43213 10.5055Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29542 16.5413L11.1208 19.3438L10.9919 19.4278L9.1665 16.6252L9.29542 16.5413Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5706 10.5039L11.1252 13.6007L10.9877 13.6697L9.43311 10.5729L9.5706 10.5039Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78464 4.02205L10.7937 1.08837L10.6482 1.03833L9.62207 4.02169L10.8336 7.59405L10.9793 7.54464L9.78464 4.02205Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastDark);
export default __webpack_public_path__ + "static/media/MastDark.f394aef8.svg";
export { ForwardRef as ReactComponent };